import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. La guía está pensada para principiantes y te acompaña paso a paso desde cero.'
}, {
  q: '¿Necesito saber dibujar?',
  a: 'No. El producto incluye plantillas para practicar y +100 plantillas listas para imprimir. Podés colocarlas debajo del vidrio, acetato o superficie transparente y usarlas como guía.'
}, {
  q: '¿Cómo se usan las plantillas?',
  a: 'Las descargás, las imprimís y las colocás debajo de la superficie que vas a pintar. Después seguís el diseño con el contorno y rellenás con color.'
}, {
  q: '¿Los materiales se consiguen fácil?',
  a: 'Sí. La guía te muestra materiales simples, alternativas económicas y qué comprar primero para empezar sin complicarte.'
}, {
  q: '¿Puedo empezar solo con las plantillas y materiales simples?',
  a: 'Sí. La guía te explica qué materiales usar y cómo empezar con opciones simples, sin invertir de más.'
}, {
  q: '¿Qué puedo crear con falso vitral?',
  a: 'Podés crear portavelas, frascos decorativos, atrapasoles, mandalas, cuadros, fanales, adornos para ventanas, souvenirs y regalos personalizados.'
}, {
  q: '¿Las plantillas sirven para vender piezas?',
  a: 'Sí. Podés usarlas para crear portavelas, frascos, atrapasoles, cuadros, souvenirs, adornos y regalos personalizados.'
}, {
  q: '¿La guía enseña a vender?',
  a: 'Sí. Incluye un bono de emprendimiento con consejos para precios, fotos, Instagram, WhatsApp, pedidos personalizados, entregas y fechas especiales.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un producto 100% digital. Recibís el acceso para descargar el material y verlo desde tu celular, computadora o tablet.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es inmediato después de la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-48" data-mp="2pmn39s4xdny1">
      <div className="text-center mb-8 sm:mb-10 px-2" data-id="element-49" data-mp="2poq2n2rywtff">
        <h2 className="text-3xl sm:text-4xl text-deco-text mb-4 font-bold leading-tight" data-id="element-50" data-mp="2kvn9uwv0lo0a">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-3 sm:space-y-4" data-id="element-51" data-mp="2fur6qlihm5vx">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[1.5rem] border border-deco-warm overflow-hidden shadow-sm" data-id="element-52" data-mp="2az1yltsejgo0" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-deco-bg transition-colors" data-id="element-53" data-mp="2ulqanj8do696">
              <span className="font-serif font-bold text-base sm:text-lg text-deco-text pr-6 leading-tight" data-id="element-54" data-mp="1n5tm4bqszx00">
                {faq.q}
              </span>
              <ChevronDown className={`text-deco-terra shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-55" data-mp="3uuy04id3orqr" />
            </button>

            <AnimatePresence data-id="element-56" data-mp="7pgrnswh9tyn">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-57" data-mp="7nvzub1jsp4h">
                  <div className="px-6 pb-6 pt-1 text-deco-text/80 leading-relaxed font-normal text-sm sm:text-base border-t border-deco-warm/50" data-id="element-58" data-mp="mcjsa8g3kiq7">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}